import { useTranslation } from 'react-i18next';
import { ReactTabulator as BaseReactTabulator } from 'react-tabulator';
import type { ReactTabulatorProps } from 'react-tabulator/lib/ReactTabulator';

export type { ColumnDefinition, ReactTabulatorOptions } from 'react-tabulator';

// react-tabulator 0.21 builds the Tabulator instance once, on mount, and only
// reacts to `data` afterwards: column titles, placeholder and footer built
// with t() keep the language that was active when the table mounted.
// Remounting the table when the language changes rebuilds them. The key sits
// on a wrapper div, not on the table itself, so Tabulator's destroy() still
// finds the element's parent; keying the table directly makes
// ResizeObserver.unobserve throw on unmount.
export const ReactTabulator = (props: ReactTabulatorProps) => {
  const { i18n } = useTranslation();
  return (
    <div key={i18n.language}>
      <BaseReactTabulator {...props} />
    </div>
  );
};
